/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import Analytics, { AppContextGetter } from 'common/debug/analytics';
// eslint-disable-next-line no-restricted-imports
import { Client } from 'common/lib/version';
// eslint-disable-next-line no-restricted-imports
import { State } from 'modules';
import { Store } from 'react-redux';
// eslint-disable-next-line no-restricted-imports
import { getMyLocalePreference, isLoggedIn } from 'selectors';

export const buildContextGetter = (store: Store<State>): AppContextGetter => {
  const clientVersion = new Client(window.clientVersion);

  return () => {
    const state = store.getState();

    return [
      {
        schema: 'iglu:com.trello/web-context/jsonschema/1-0-4',
        data: {
          client_version: clientVersion.toString(),
          client_locale: isLoggedIn(state)
            ? getMyLocalePreference(state)
            : 'en',
        },
      },
    ];
  };
};

export default new Analytics();



// WEBPACK FOOTER //
// ./app/gamma/src/debug/analytics.ts